<template>
  <div class="radio" :class="{ selected, other, wide, oval }" @click="onClick">
    <span><slot></slot></span>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: () => ''
    },
    selected: {
      type: Boolean,
      default: () => false
    },
    oval: {
      type: Boolean,
      default: () => false
    },
    other: {
      type: Boolean,
      default: () => false
    },
    wide: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {},
  methods: {
    onClick(e) {
      this.$emit('click', this.value, this.entity);
    }
  }
};
</script>

<style lang="scss" scoped>
.radio {
  align-items: center;
  background-color: $white;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  flex: 0 0 55px;
  height: 55px;
  justify-content: center;
  margin-bottom: 8px;
  margin-right: 10px;
  opacity: 1;
  transition: 0.3s ease-in-out background-color, 0.3s ease-in-out opacity;
  width: 55px;

  &.oval {
    white-space: nowrap;
    border-radius: 33px;
    padding: 0 20px;
    flex: 0 0 auto;
    width: auto;
  }

  &.wide {
    flex: 1 0 auto;
    border-radius: 8px;
    width: 100%;
    min-height: 55px;
    height: auto;
    padding: 12px;

    margin-right: 0;
    span {
      font-weight: 600;
    }
  }

  span {
    color: $black;
    font-size: 18px;
    font-weight: 500;
    line-height: 140%;
    text-align: center;
    transition: 0.3s ease-in-out color;
  }

  &.selected {
    background-color: $green;

    span {
      color: $white;
    }
  }

  &.other {
    opacity: 0.5;
  }
}
</style>
